import * as React from 'react';
import Loading from './Loading';

export interface InfoCardProps {
  title: string;
  value: string;
  icon: any;
  isLoading: boolean;
  color: 'primary' | 'active' | 'danger' | 'secondary' | 'warning' | 'inactive';
  className?: string; // Adding optional className prop
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value, color, icon, isLoading, className = '' }) => {
  const getColor = React.useCallback((): string => {
    switch (color) {
      case 'danger':
        return '#FB0303';
      case 'active':
        return '#088306';
      case 'warning':
        return '#FF6702';
      case 'inactive':
        return '#4E4E4E';
      case 'secondary':
        return '#3A6EA7';
      case 'primary':
        return '#FF6702';
      default:
        return color;
    }
  }, [color]);

  return (
    <div className={`info-card ${className}`}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="flex  justify-between items-center">
            <div className="flex relative w-full bg-white rounded-sm ">
              <div
                className={` mx-auto 360:w-[165px]  375:w-[165px]  sm:ml-[-4em] w-[165px] h-[80px]  sm:w-[220px] md:w-[380px] bigmd:w-[440px] biglg:w-[220px] md:h-[88px] md:ml-[0px] 1180:w-[135px] gap-3 xl:w-[266px] lg:w-[220px] 1220:w-[155px]  2xl:w-[290px] xl:ml-[1em]  rounded flex items-center xl:h-[121px] lg:h-[121px] xl:gap-[10px] lg:gap-[12px] lg:pl-[0px] md:pl-0md pl-[30px] xl:pl-[50px] ${className}`}
              >
                <div className=" bg-blue-50 ml-[-1em] sm:ml-[3em]  414:ml-[-0.5em] lg:ml-[3em] md:ml-[0em] xl:ml-[-2em] 2xl:ml-[-2em] w-[36px] h-[36px] xl:w-11 lg:max-xl-p-10 xl:h-[45px] flex rounded-full justify-center items-center">
                  <p>{icon}</p>
                </div>
                <div className="flex flex-col items-start gap-0.5 xl:ml-[] ">
                  <p className="  font-['Fellix'] text-xs font-medium leading-[1.375rem] text-[#828282] whitespace-nowrap text-[12px] xl:text-xs tracking-wide">
                    {title}
                  </p>
                  <p
                    className={`py-[2px] text-center font-['Fellix'] text-xl  leading-[1.375rem] font-semibold text-[12px] md:text-[20px] xl:text-xl text-[${getColor()}]`}
                  >
                    {value}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export { InfoCard };

